import { gql } from 'graphql-request'

export const LINK_WITH_NAIIN = gql`
  mutation LinkWithNaiin($linkWithNaiinInput: LinkWithNaiinInput!) {
    linkWithNaiin(linkWithNaiinInput: $linkWithNaiinInput) {
      message
    }
  }
`
